import { environment } from 'src/environments/environment';

export default class TimelineUtils {

  static formatTimeCallback(seconds): string {
    const addZero = (n) => (n < 10 ? '0' + n : n);

    let minutes: any = Math.floor(seconds / 60);
    seconds = minutes >= 1 ? seconds % 60 : seconds;

    minutes = addZero(minutes);
    seconds = addZero(seconds);

    return `${minutes}:${seconds}`;
  }

  static timeInterval(pxPerSec): number {
    let interval = 60;
    if (pxPerSec >= 5 * environment.wavesurferZoom) {
      interval = 1;
    } else if (pxPerSec >= 4 * environment.wavesurferZoom) {
      interval = 2.5;
    } else if (pxPerSec >= 3 * environment.wavesurferZoom) {
      interval = 5;
    } else if (pxPerSec >= 2 * environment.wavesurferZoom) {
      interval = 10;
    } else if (pxPerSec >= environment.wavesurferZoom) {
      interval = 15;
    }
    return interval;
  }

  static secondaryLabelInterval(pxPerSec): number {
    const calcLabelBasedOnSec = (secondsInterval) => {
      return Math.floor(secondsInterval / TimelineUtils.timeInterval(pxPerSec));
    };
    let label = calcLabelBasedOnSec(300);

    if (pxPerSec >= 12 * environment.wavesurferZoom) {
      label = calcLabelBasedOnSec(1.25);
    } else if (pxPerSec >= 7 * environment.wavesurferZoom) {
      label = calcLabelBasedOnSec(2.5);
    } else if (pxPerSec >= 4 * environment.wavesurferZoom) {
      label = calcLabelBasedOnSec(5);
    } else if (pxPerSec >= 3 * environment.wavesurferZoom) {
      label = calcLabelBasedOnSec(10);
    } else if (pxPerSec >= 2 * environment.wavesurferZoom) {
      label = calcLabelBasedOnSec(20);
    } else if (pxPerSec >= environment.wavesurferZoom) {
      label = calcLabelBasedOnSec(60);
    }
    return label;
  }

}
